import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer-container">
      <Row className="m-0">
        <Col sm={1} xs={1} className="my-auto">
          <img
            alt="GM Logo"
            src={"/resources/gm-logo-white.png"}
            height="25px"
            width="25px"
          />
        </Col>
        <Col sm={11} xs={11} className={`my-auto footer-text-container`}>
          <p className="text-white m-0">
            © General Motors {new Date().getFullYear()} |{" "}
            <a
              href="https://socrates.gm.com/socratessites/usa/en/gm/home/privacy.html"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <span className="lang-footer-privacy-text text-white">
                Privacy
              </span>
            </a>
          </p>
        </Col>
      </Row>
    </footer>
  );
}
